"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1340],{

/***/ 59012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ ShopProductSort; },
/* harmony export */   "ZW": function() { return /* binding */ ShopProductSortForPage; },
/* harmony export */   "cQ": function() { return /* binding */ ChromeExtensionPromptsOrder; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83321);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18972);
/* harmony import */ var _components_Iconify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42445);
/* harmony import */ var _components_MenuPopover__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48731);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25168);






var ChromeExtensionPromptsOrder;
(function(ChromeExtensionPromptsOrder) {
    ChromeExtensionPromptsOrder["UsagesDesc"] = "usages_DESC";
    ChromeExtensionPromptsOrder["UsagesAsc"] = "usages_ASC";
    ChromeExtensionPromptsOrder["LikesDesc"] = "likes_DESC";
    ChromeExtensionPromptsOrder["LikesAsc"] = "likes_ASC";
    ChromeExtensionPromptsOrder["ViewsAsc"] = "views_ASC";
    ChromeExtensionPromptsOrder["ViewsDesc"] = "views_DESC";
    ChromeExtensionPromptsOrder["CreatedAtAsc"] = "createdAt_ASC";
    ChromeExtensionPromptsOrder["CreatedAtDesc"] = "createdAt_DESC";
})(ChromeExtensionPromptsOrder || (ChromeExtensionPromptsOrder = {}));
var ShopProductSortForPage;
(function(ShopProductSortForPage) {
    ShopProductSortForPage["product"] = "product";
    ShopProductSortForPage["chromeExtensionPrompt"] = "chromeExtensionPrompt";
})(ShopProductSortForPage || (ShopProductSortForPage = {}));
var SORT_BY_OPTIONS = [
    {
        value: _generated_graphql__WEBPACK_IMPORTED_MODULE_4__/* .ProductsOrder.SysPublishedAtDesc */ .OEG.SysPublishedAtDesc,
        label: "Newest",
        forType: ShopProductSortForPage.product
    },
    {
        value: _generated_graphql__WEBPACK_IMPORTED_MODULE_4__/* .ProductsOrder.SysPublishedAtAsc */ .OEG.SysPublishedAtAsc,
        label: "Oldest",
        forType: ShopProductSortForPage.product
    },
    {
        value: _generated_graphql__WEBPACK_IMPORTED_MODULE_4__/* .ProductsOrder.TitleAsc */ .OEG.TitleAsc,
        label: "Name: A-Z",
        forType: ShopProductSortForPage.product
    },
    {
        value: _generated_graphql__WEBPACK_IMPORTED_MODULE_4__/* .ProductsOrder.TitleDesc */ .OEG.TitleDesc,
        label: "Name: Z-A",
        forType: ShopProductSortForPage.product
    }, 
];
var SORT_BY_FOR_CHROME_EXTENSION_PAGE_OPTIONS = [
    {
        value: ChromeExtensionPromptsOrder.UsagesDesc,
        label: "Usages Desc",
        forType: ShopProductSortForPage.chromeExtensionPrompt
    },
    {
        value: ChromeExtensionPromptsOrder.UsagesAsc,
        label: "Usages Asc",
        forType: ShopProductSortForPage.chromeExtensionPrompt
    },
    {
        value: ChromeExtensionPromptsOrder.LikesDesc,
        label: "Likes Desc",
        forType: ShopProductSortForPage.chromeExtensionPrompt
    },
    {
        value: ChromeExtensionPromptsOrder.LikesAsc,
        label: "Likes Asc",
        forType: ShopProductSortForPage.chromeExtensionPrompt
    },
    {
        value: ChromeExtensionPromptsOrder.ViewsDesc,
        label: "Views Desc",
        forType: ShopProductSortForPage.chromeExtensionPrompt
    },
    {
        value: ChromeExtensionPromptsOrder.ViewsAsc,
        label: "Views Asc",
        forType: ShopProductSortForPage.chromeExtensionPrompt
    },
    {
        value: ChromeExtensionPromptsOrder.CreatedAtAsc,
        label: "Newest",
        forType: ShopProductSortForPage.chromeExtensionPrompt
    },
    {
        value: ChromeExtensionPromptsOrder.CreatedAtDesc,
        label: "Oldest",
        forType: ShopProductSortForPage.chromeExtensionPrompt
    }, 
];
function renderLabelForProduct(value) {
    var foundedOption = SORT_BY_OPTIONS.find(function(option) {
        return option.value === value;
    });
    return (foundedOption === null || foundedOption === void 0 ? void 0 : foundedOption.label) || SORT_BY_OPTIONS[0].label;
}
function renderLabelForChrome(value) {
    var foundedOption = SORT_BY_FOR_CHROME_EXTENSION_PAGE_OPTIONS.find(function(option) {
        return option.value === value;
    });
    return (foundedOption === null || foundedOption === void 0 ? void 0 : foundedOption.label) || SORT_BY_FOR_CHROME_EXTENSION_PAGE_OPTIONS[0].label;
}
var DEFAULT_PRODUCTS_ORDERS = _generated_graphql__WEBPACK_IMPORTED_MODULE_4__/* .ProductsOrder.SysPublishedAtDesc */ .OEG.SysPublishedAtDesc;
function ShopProductSort(props) {
    var value = props.value, onSort = props.onSort, _forPage = props.forPage, forPage = _forPage === void 0 ? ShopProductSortForPage.product : _forPage, defaultValue = props.defaultValue;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(undefined), sortBy = ref[0], setSortBy = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), open = ref1[0], setOpen = ref1[1];
    var handleOpen = function(currentTarget) {
        setOpen(currentTarget);
    };
    var handleClose = function() {
        setOpen(null);
    };
    var options = [];
    if (forPage === ShopProductSortForPage.product) {
        options = SORT_BY_OPTIONS;
    }
    if (forPage === ShopProductSortForPage.chromeExtensionPrompt) {
        options = SORT_BY_FOR_CHROME_EXTENSION_PAGE_OPTIONS;
    }
    var handleSortBy = function(value) {
        var url = new URL(window.location.href);
        if (value) {
            if (value === DEFAULT_PRODUCTS_ORDERS) {
                url.searchParams.delete("sort");
            } else {
                url.searchParams.set("sort", value);
            }
        } else {
            url.searchParams.delete("sort");
        }
        window.history.replaceState(null, "", url.toString());
        handleClose();
        setSortBy(value);
        if (value) {
            if (props.forPage === ShopProductSortForPage.chromeExtensionPrompt) {
                var onSortChrome = onSort;
                onSortChrome(value);
            }
            if (props.forPage === ShopProductSortForPage.product) {
                var onSortProduct = onSort;
                onSortProduct(value);
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (value !== sortBy) {
            if (value) {
                setTimeout(function() {
                    return setSortBy(value);
                }, 100);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        value
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                fullWidth: true,
                color: "inherit",
                variant: "outlined",
                size: "large",
                disableRipple: true,
                onClick: function(event) {
                    return handleOpen(event.currentTarget);
                },
                endIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    icon: open ? "eva:chevron-up-fill" : "eva:chevron-down-fill"
                }),
                sx: {
                    display: "inline-flex"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "subtitle2",
                        children: "Sort By:\xa0"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "subtitle2",
                        sx: {
                            color: "text.secondary"
                        },
                        children: [
                            sortBy && props.forPage === ShopProductSortForPage.chromeExtensionPrompt && renderLabelForChrome(sortBy),
                            sortBy && props.forPage === ShopProductSortForPage.product && renderLabelForProduct(sortBy)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MenuPopover__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                anchorEl: open,
                open: Boolean(open),
                onClose: handleClose,
                sx: {
                    width: "auto",
                    "& .MuiMenuItem-root": {
                        typography: "body2",
                        borderRadius: 0.75
                    }
                },
                children: options.map(function(option) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        selected: option.value === sortBy,
                        onClick: function() {
                            if (option.forType === ShopProductSortForPage.product) {
                                handleSortBy(option.value);
                            }
                            if (option.forType === ShopProductSortForPage.chromeExtensionPrompt) {
                                handleSortBy(option.value);
                            }
                        },
                        children: option.label
                    }, option.value);
                })
            })
        ]
    });
}


/***/ }),

/***/ 21340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n4": function() { return /* reexport */ ShopFilterSidebar; },
  "wk": function() { return /* reexport */ ShopFilterTopBar; },
  "a8": function() { return /* reexport */ ShopProductCard; },
  "W": function() { return /* reexport */ ShopProductSearch; },
  "a5": function() { return /* reexport */ ShopProductSort/* default */.ZP; },
  "vc": function() { return /* reexport */ ShopTagFiltered; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(50122);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./src/utils/formatNumber.ts
var formatNumber = __webpack_require__(13162);
// EXTERNAL MODULE: ./src/components/Label.tsx
var Label = __webpack_require__(4930);
// EXTERNAL MODULE: ./src/components/Image.tsx
var Image = __webpack_require__(97349);
// EXTERNAL MODULE: ./src/hooks/useLocales.ts + 3 modules
var useLocales = __webpack_require__(67918);
;// CONCATENATED MODULE: ./src/sections/e-commerce/shop/ShopProductCard.tsx
// next


// @mui

// routes
// utils

// components



function ShopProductCard(param) {
    var product = param.product;
    var currentLang = (0,useLocales/* default */.Z)().currentLang;
    var title = product.title, price = product.price, slug = product.slug, previewUrl = product.previewUrl, abstract = product.abstract, tags = product.tags;
    var linkTo = "/".concat(currentLang.value, "/product/").concat(slug);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: linkTo,
        locale: false,
        hrefLang: currentLang.value,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            sx: {
                cursor: "pointer"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                href: linkTo,
                hrefLang: currentLang.value,
                style: {
                    textDecoration: "none",
                    color: "inherit"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            position: "relative"
                        },
                        children: [
                            Boolean(tags.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                                variant: "filled",
                                color: tags[0].name === "sale" && "error" || "info",
                                sx: {
                                    top: 16,
                                    right: 16,
                                    zIndex: 9,
                                    position: "absolute",
                                    textTransform: "uppercase"
                                },
                                children: tags[0].name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                alt: title,
                                src: previewUrl !== null && previewUrl !== void 0 ? previewUrl : "",
                                ratio: "1/1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        spacing: 2,
                        sx: {
                            p: 3
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                color: "inherit",
                                href: linkTo,
                                hrefLang: currentLang.value,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "subtitle2",
                                    noWrap: true,
                                    children: title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "caption",
                                style: {
                                    display: "-webkit-box",
                                    WebkitLineClamp: 5,
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis"
                                },
                                children: abstract
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                        direction: "row",
                                        spacing: 0.5,
                                        children: price && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            children: (0,formatNumber/* fCurrency */.e_)(price)
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./src/sections/e-commerce/shop/ShopProductSort.tsx
var ShopProductSort = __webpack_require__(59012);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 3 modules
var TextField = __webpack_require__(41997);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(87109);
// EXTERNAL MODULE: ./src/components/Iconify.tsx
var Iconify = __webpack_require__(42445);
;// CONCATENATED MODULE: ./src/sections/e-commerce/shop/ShopProductSearch.tsx








function ShopProductSearch(props) {
    var value = props.value, onSearch = props.onSearch, textFieldProps = props.textFieldProps;
    var ref = (0,react.useState)(value !== null && value !== void 0 ? value : ""), searchQuery = ref[0], setSearchQuery = ref[1];
    var debounceSetSearchValue = (0,react.useCallback)(debounce_default()(function(_searchVal) {
        var url = new URL(window.location.href);
        if (_searchVal) {
            url.searchParams.set("search", _searchVal);
        } else {
            url.searchParams.delete("search");
        }
        window.history.replaceState(null, "", url);
        onSearch === null || onSearch === void 0 ? void 0 : onSearch(_searchVal);
    }, 650), []);
    var handleChangeSearch = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                try {
                    setSearchQuery(value);
                    debounceSetSearchValue(value);
                } catch (error) {
                    console.error(error);
                }
                return [
                    2
                ];
            });
        });
        return function handleChangeSearch(value) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if ((value === null || value === void 0 ? void 0 : value.toLowerCase()) !== searchQuery.toLowerCase()) {
            setTimeout(function() {
                return setSearchQuery(value !== null && value !== void 0 ? value : "");
            }, 200);
        }
    }, [
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread/* default */.Z)({
        value: searchQuery,
        onChange: function(event) {
            return handleChangeSearch(event.target.value);
        },
        placeholder: "Search",
        InputProps: {
            startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                position: "start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                    icon: "eva:search-fill",
                    sx: {
                        color: "text.disabled",
                        width: 20,
                        height: 20
                    }
                })
            }),
            endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                position: "end",
                style: {
                    cursor: "pointer"
                },
                onClick: function() {
                    return handleChangeSearch("");
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                    icon: "akar-icons:cross"
                })
            })
        }
    }, textFieldProps));
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 1 modules
var Drawer = __webpack_require__(58826);
// EXTERNAL MODULE: ./node_modules/@mui/material/Toolbar/Toolbar.js + 1 modules
var Toolbar = __webpack_require__(10155);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(57922);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(50480);
// EXTERNAL MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js + 4 modules
var Checkbox = __webpack_require__(69368);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(40549);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./src/utils/cssStyles.ts
var cssStyles = __webpack_require__(20727);
// EXTERNAL MODULE: ./node_modules/lodash/groupBy.js
var groupBy = __webpack_require__(7739);
var groupBy_default = /*#__PURE__*/__webpack_require__.n(groupBy);
// EXTERNAL MODULE: ./node_modules/lodash/uniq.js
var uniq = __webpack_require__(44908);
var uniq_default = /*#__PURE__*/__webpack_require__.n(uniq);
// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(89734);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ./src/config.ts
var config = __webpack_require__(86704);
// EXTERNAL MODULE: ./src/components/Scrollbar.tsx
var Scrollbar = __webpack_require__(84855);
// EXTERNAL MODULE: ./src/hooks/useCollapseDrawer.ts
var useCollapseDrawer = __webpack_require__(67854);
// EXTERNAL MODULE: ./src/components/animate/index.ts + 12 modules
var animate = __webpack_require__(76843);
;// CONCATENATED MODULE: ./src/sections/e-commerce/shop/CollapseButton.tsx
// @mui



// components

function CollapseButton(param) {
    var onToggleCollapse = param.onToggleCollapse, collapseClick = param.collapseClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(animate/* IconButtonAnimate */.w_, {
        onClick: onToggleCollapse,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: (0,_object_spread/* default */.Z)({
                lineHeight: 0,
                transition: function(theme) {
                    return theme.transitions.create("transform", {
                        duration: theme.transitions.duration.shorter
                    });
                }
            }, collapseClick && {
                transform: "rotate(180deg)"
            }),
            children: icon
        })
    });
}
// ----------------------------------------------------------------------
var icon = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    width: "24",
    height: "24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
        fill: "none",
        fillRule: "evenodd",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "currentColor",
                fillRule: "nonzero",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.3283 11.4343 18.5126 7.25c.4142-.4142.4142-1.0858 0-1.5-.4142-.4142-1.0858-.4142-1.5 0l-5.543 5.5429c-.3904.3905-.3904 1.0237 0 1.4142l5.543 5.5429c.4142.4142 1.0858.4142 1.5 0 .4142-.4142.4142-1.0858 0-1.5l-4.1843-4.1843a.8.8 0 0 1 0-1.1314Z",
                        opacity: ".48"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.3283 11.4343 12.5126 7.25c.4142-.4142.4142-1.0858 0-1.5-.4142-.4142-1.0858-.4142-1.5 0l-5.543 5.5429c-.3904.3905-.3904 1.0237 0 1.4142l5.543 5.5429c.4142.4142 1.0858.4142 1.5 0 .4142-.4142.4142-1.0858 0-1.5l-4.1843-4.1843a.8.8 0 0 1 0-1.1314Z"
                    })
                ]
            })
        ]
    })
});

// EXTERNAL MODULE: ./src/components/nav-section/vertical/style.ts
var style = __webpack_require__(91625);
;// CONCATENATED MODULE: ./src/sections/e-commerce/shop/ShopFilterSidebar.tsx







// @mui






// @types

// components





var RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({}, theme.breakpoints.up("lg"), {
        flexShrink: 0,
        transition: theme.transitions.create("width", {
            duration: theme.transitions.duration.shorter
        })
    });
});
function ShopFilterSidebar(param) {
    var filteredTagIds = param.filteredTagIds, filterTags = param.filterTags, isOpen = param.isOpen, onFilterTagIds = param.onFilterTagIds, onRemoveTagId = param.onRemoveTagId, onAddTagId = param.onAddTagId, onResetAll = param.onResetAll, onOpen = param.onOpen, onClose = param.onClose;
    var theme = (0,useTheme/* default */.Z)();
    var ref = (0,useCollapseDrawer/* default */.Z)(), isCollapse = ref.isCollapse, collapseClick = ref.collapseClick, collapseHover = ref.collapseHover, onToggleCollapse = ref.onToggleCollapse, onHoverEnter = ref.onHoverEnter, onHoverLeave = ref.onHoverLeave;
    var groupByNameTags = groupBy_default()(filterTags, "groupName");
    var handleSetTag = function(tag, action) {
        var url = new URL(window.location.href);
        var tagsParamsString = url.searchParams.get("tags");
        var tagSearch = "".concat(tag.sys.id, "_").concat(tag.name);
        var tagsIdWithNameParams = [];
        if (tagsParamsString) {
            tagsIdWithNameParams = tagsParamsString.split("|").filter(function(tag) {
                var tagId = tag.split("_")[0];
                var ref;
                return (ref = filterTags === null || filterTags === void 0 ? void 0 : filterTags.some(function(filterTag) {
                    return tagId === filterTag.sys.id;
                })) !== null && ref !== void 0 ? ref : false;
            });
        }
        if (action === "add") {
            tagsIdWithNameParams = uniq_default()((0,_to_consumable_array/* default */.Z)(tagsIdWithNameParams).concat([
                tagSearch
            ]));
            onAddTagId === null || onAddTagId === void 0 ? void 0 : onAddTagId(tag.sys.id);
        } else {
            tagsIdWithNameParams = uniq_default()(tagsIdWithNameParams.filter(function(tagIdWithName) {
                return tagIdWithName !== tagSearch;
            }));
            onRemoveTagId === null || onRemoveTagId === void 0 ? void 0 : onRemoveTagId(tag.sys.id);
        }
        if (tagsIdWithNameParams.length) {
            url.searchParams.set("tags", tagsIdWithNameParams.join("|"));
        } else {
            url.searchParams.delete("tags");
        }
        window.history.replaceState(null, "", url);
    };
    var handleResetAll = function() {
        var url = new URL(window.location.href);
        url.searchParams.delete("tags");
        window.history.replaceState(null, "", url);
        onResetAll === null || onResetAll === void 0 ? void 0 : onResetAll();
    };
    var sharedBorderRightStyle = {
        borderRight: "1px dashed rgba(145, 158, 171, 0.24)"
    };
    var ref1, ref2, _name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RootStyle, {
        sx: (0,_object_spread/* default */.Z)({
            width: {
                lg: isCollapse ? config/* NAVBAR.BASE_COLLAPSE_WIDTH */.Au.BASE_COLLAPSE_WIDTH : config/* NAVBAR.BASE_WIDTH */.Au.BASE_WIDTH
            }
        }, collapseClick && {
            position: "absolute"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer/* default */.ZP, {
            open: true,
            variant: "permanent",
            // onMouseEnter={onHoverEnter}
            // onMouseLeave={onHoverLeave}
            PaperProps: {
                sx: (0,_object_spread/* default */.Z)({
                    width: config/* NAVBAR.BASE_WIDTH */.Au.BASE_WIDTH,
                    borderRightStyle: "none",
                    bgcolor: "background.default",
                    zIndex: 1099,
                    transition: function(theme) {
                        return theme.transitions.create("width", {
                            duration: theme.transitions.duration.standard
                        });
                    }
                }, isCollapse && {
                    width: config/* NAVBAR.BASE_COLLAPSE_WIDTH */.Au.BASE_COLLAPSE_WIDTH
                }, collapseHover && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,cssStyles/* default */.Z)(theme).bgBlur()), {
                    boxShadow: function(theme) {
                        return theme.customShadows.z24;
                    }
                }))
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Toolbar/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Toolbar/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: isCollapse ? "column" : "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    sx: (0,_object_spread/* default */.Z)({
                        px: 1,
                        py: 2
                    }, sharedBorderRightStyle),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "subtitle1",
                            sx: {
                                ml: 1,
                                mb: 1
                            },
                            children: [
                                "Filters",
                                isCollapse ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        "( ",
                                        (ref1 = filterTags === null || filterTags === void 0 ? void 0 : filterTags.length) !== null && ref1 !== void 0 ? ref1 : 0,
                                        " )"
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        " ( ",
                                        (ref2 = filterTags === null || filterTags === void 0 ? void 0 : filterTags.length) !== null && ref2 !== void 0 ? ref2 : 0,
                                        " )"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapseButton, {
                            onToggleCollapse: onToggleCollapse,
                            collapseClick: collapseClick
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Scrollbar/* default */.Z, {
                    sx: sharedBorderRightStyle,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        spacing: 3,
                        sx: {
                            p: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                            spacing: 1,
                            children: sortBy_default()(Object.entries(groupByNameTags), [
                                function(param) {
                                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _ = _param[0], groupedTags = _param[1];
                                    return groupedTags.length;
                                }
                            ]).reverse().map(function(param) {
                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), groupName = _param[0], groupedTags = _param[1];
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListRoot, {
                                        isCollapse: isCollapse !== null && isCollapse !== void 0 ? isCollapse : false,
                                        list: {
                                            title: groupName || "Others",
                                            children: groupedTags.map(function(groupedTag) {
                                                return {
                                                    id: groupedTag.sys.id,
                                                    title: (_name = groupedTag.name) !== null && _name !== void 0 ? _name : "",
                                                    checked: filteredTagIds.includes(groupedTag.sys.id),
                                                    onChecked: function() {
                                                        handleSetTag(groupedTag, filteredTagIds.includes(groupedTag.sys.id) ? "remove" : "add");
                                                    }
                                                };
                                            })
                                        }
                                    })
                                }, groupName || "Others");
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: (0,_object_spread/* default */.Z)({
                        p: 3
                    }, sharedBorderRightStyle),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        fullWidth: true,
                        size: "large",
                        type: "submit",
                        color: "inherit",
                        variant: "outlined",
                        onClick: handleResetAll,
                        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                            icon: "ic:round-clear-all"
                        }),
                        sx: isCollapse ? {
                            opacity: 0
                        } : {
                            opacity: 1
                        },
                        children: "Clear All"
                    })
                })
            ]
        })
    });
}
function ListRoot(param) {
    var list = param.list, isCollapse = param.isCollapse;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemRoot, {
                item: list,
                isCollapse: isCollapse,
                open: open,
                onOpen: function() {
                    return setOpen(!open);
                }
            }),
            !isCollapse && /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                in: open,
                timeout: "auto",
                unmountOnExit: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                    component: "div",
                    disablePadding: true,
                    children: list.children.map(function(item) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                            sx: {
                                display: "block",
                                ml: 0.5
                            },
                            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                size: "small",
                                checked: item.checked,
                                onChange: function() {
                                    var ref;
                                    return (ref = item.onChecked) === null || ref === void 0 ? void 0 : ref.call(item);
                                }
                            }),
                            label: item.title
                        }, item.id);
                    })
                })
            })
        ]
    });
}
function ItemRoot(param) {
    var item = param.item, isCollapse = param.isCollapse, _open = param.open, open = _open === void 0 ? false : _open, active = param.active, onOpen = param.onOpen;
    var title = item.title, children = item.children;
    var renderContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* ListItemTextStyle */.Zw, {
                disableTypography: true,
                primary: "".concat(title, " ( ").concat(children.length, " )"),
                isCollapse: isCollapse
            }),
            !isCollapse && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: children && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon, {
                    open: open
                })
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* ListItemStyle */.qd, {
        onClick: onOpen,
        activeRoot: active,
        children: renderContent
    });
}
function ArrowIcon(param) {
    var open = param.open;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
        icon: open ? "eva:arrow-ios-downward-fill" : "eva:arrow-ios-forward-fill",
        sx: {
            width: 16,
            height: 16,
            ml: 1
        }
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Chip/Chip.js + 2 modules
var Chip = __webpack_require__(99062);
// EXTERNAL MODULE: ./node_modules/lodash/find.js
var find = __webpack_require__(13311);
var find_default = /*#__PURE__*/__webpack_require__.n(find);
;// CONCATENATED MODULE: ./src/sections/e-commerce/shop/ShopTagFiltered.tsx
// @mui




// components



// ----------------------------------------------------------------------
var ShopTagFiltered_RootStyle = (0,styled/* default */.ZP)("div")({
    flexGrow: 1,
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center"
});
var WrapperStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        overflow: "hidden",
        alignItems: "stretch",
        margin: theme.spacing(0.5),
        borderRadius: theme.shape.borderRadius,
        border: "solid 1px ".concat(theme.palette.divider)
    };
});
var LabelStyle = (0,styled/* default */.ZP)(function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        component: "span",
        variant: "subtitle2"
    }, props));
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(0, 1),
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.background.neutral,
        borderRight: "solid 1px ".concat(theme.palette.divider)
    };
});
function ShopTagFiltered(param) {
    var allSearchTags = param.allSearchTags, filters = param.filters, _isShowReset = param.isShowReset, isShowReset = _isShowReset === void 0 ? true : _isShowReset, onRemoveTagId = param.onRemoveTagId, onResetAll = param.onResetAll;
    var tagIds = filters.tagIds;
    var handleRemoveTag = function(tag) {
        if (!tag) return;
        var url = new URL(window.location.href);
        var tagsParamsString = url.searchParams.get("tags");
        var tagSearch = "".concat(tag.sys.id, "_").concat(tag.name);
        var tagsIdWithNameParams = [];
        if (tagsParamsString) {
            tagsIdWithNameParams = tagsParamsString.split("|").filter(function(tag) {
                var tagId = tag.split("_")[0];
                return allSearchTags.some(function(filterTag) {
                    return tagId === filterTag.sys.id;
                });
            });
        }
        tagsIdWithNameParams = uniq_default()(tagsIdWithNameParams.filter(function(tagIdWithName) {
            return tagIdWithName !== tagSearch;
        }));
        onRemoveTagId === null || onRemoveTagId === void 0 ? void 0 : onRemoveTagId(tag.sys.id);
        if (tagsIdWithNameParams.length) {
            url.searchParams.set("tags", tagsIdWithNameParams.join("|"));
        } else {
            url.searchParams.delete("tags");
        }
        window.history.replaceState(null, "", url);
    };
    var handleResetAll = function() {
        var url = new URL(window.location.href);
        url.searchParams.delete("tags");
        window.history.replaceState(null, "", url);
        onResetAll === null || onResetAll === void 0 ? void 0 : onResetAll();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShopTagFiltered_RootStyle, {
        children: [
            tagIds.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperStyle, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelStyle, {
                        children: "Tag:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        direction: "row",
                        flexWrap: "wrap",
                        sx: {
                            p: 0.75
                        },
                        children: tagIds.map(function(tagId) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                label: (ref = find_default()(allSearchTags, {
                                    sys: {
                                        id: tagId
                                    }
                                })) === null || ref === void 0 ? void 0 : ref.name,
                                size: "small",
                                onDelete: function() {
                                    return handleRemoveTag(find_default()(allSearchTags, {
                                        sys: {
                                            id: tagId
                                        }
                                    }));
                                },
                                sx: {
                                    m: 0.5
                                }
                            }, tagId);
                        })
                    })
                ]
            }),
            isShowReset && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                color: "error",
                size: "small",
                onClick: handleResetAll,
                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                    icon: "ic:round-clear-all"
                }),
                children: "Clear All"
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/nav-section/horizontal/style.ts
var horizontal_style = __webpack_require__(74665);
;// CONCATENATED MODULE: ./src/sections/e-commerce/shop/ShopFilterTopBar.tsx







// @mui





// @types
// components




var hideScrollbar = {
    msOverflowStyle: "none",
    scrollbarWidth: "none",
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
        display: "none"
    }
};
var ShopFilterTopBar_RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        transition: theme.transitions.create("top", {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter
        }),
        width: "100%",
        position: "fixed",
        zIndex: theme.zIndex.appBar,
        padding: theme.spacing(1, 0),
        boxShadow: theme.customShadows.z8,
        top: config/* HEADER.MOBILE_HEIGHT */.yf.MOBILE_HEIGHT,
        backgroundColor: theme.palette.background.default
    }, theme.breakpoints.up("md"), {
        top: config/* HEADER.MAIN_DESKTOP_OFFSET_HEIGHT */.yf.MAIN_DESKTOP_OFFSET_HEIGHT
    });
});
function ShopFilterTopBar(param) {
    var filteredTagIds = param.filteredTagIds, filterTags = param.filterTags, isOpen = param.isOpen, onFilterTagIds = param.onFilterTagIds, onRemoveTagId = param.onRemoveTagId, onAddTagId = param.onAddTagId, onResetAll = param.onResetAll, onOpen = param.onOpen, onClose = param.onClose;
    var theme = (0,useTheme/* default */.Z)();
    var ref = (0,useCollapseDrawer/* default */.Z)(), isCollapse = ref.isCollapse, collapseClick = ref.collapseClick, collapseHover = ref.collapseHover, onToggleCollapse = ref.onToggleCollapse, onHoverEnter = ref.onHoverEnter, onHoverLeave = ref.onHoverLeave;
    var groupByNameTags = groupBy_default()(filterTags, "groupName");
    var handleSetTag = function(tag, action) {
        var url = new URL(window.location.href);
        var tagsParamsString = url.searchParams.get("tags");
        var tagSearch = "".concat(tag.sys.id, "_").concat(tag.name);
        var tagsIdWithNameParams = [];
        if (tagsParamsString) {
            tagsIdWithNameParams = tagsParamsString.split("|").filter(function(tag) {
                var tagId = tag.split("_")[0];
                var ref;
                return (ref = filterTags === null || filterTags === void 0 ? void 0 : filterTags.some(function(filterTag) {
                    return tagId === filterTag.sys.id;
                })) !== null && ref !== void 0 ? ref : false;
            });
        }
        if (action === "add") {
            tagsIdWithNameParams = uniq_default()((0,_to_consumable_array/* default */.Z)(tagsIdWithNameParams).concat([
                tagSearch
            ]));
            onAddTagId === null || onAddTagId === void 0 ? void 0 : onAddTagId(tag.sys.id);
        } else {
            tagsIdWithNameParams = uniq_default()(tagsIdWithNameParams.filter(function(tagIdWithName) {
                return tagIdWithName !== tagSearch;
            }));
            onRemoveTagId === null || onRemoveTagId === void 0 ? void 0 : onRemoveTagId(tag.sys.id);
        }
        if (tagsIdWithNameParams.length) {
            url.searchParams.set("tags", tagsIdWithNameParams.join("|"));
        } else {
            url.searchParams.delete("tags");
        }
        window.history.replaceState(null, "", url);
    };
    var _name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopFilterTopBar_RootStyle, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
            direction: "row",
            justifyContent: "center",
            sx: {
                bgcolor: "background.neutral",
                px: 0.5
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                direction: "row",
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hideScrollbar), {
                    py: 1
                }),
                children: sortBy_default()(Object.entries(groupByNameTags), [
                    function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _ = _param[0], groupedTags = _param[1];
                        return groupedTags.length;
                    }
                ]).reverse().map(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), groupName = _param[0], groupedTags = _param[1];
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        direction: "row",
                        flexShrink: 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopFilterTopBar_ListRoot, {
                            isCollapse: isCollapse !== null && isCollapse !== void 0 ? isCollapse : false,
                            list: {
                                title: groupName || "Others",
                                children: groupedTags.map(function(groupedTag) {
                                    return {
                                        id: groupedTag.sys.id,
                                        title: (_name = groupedTag.name) !== null && _name !== void 0 ? _name : "",
                                        checked: filteredTagIds.includes(groupedTag.sys.id),
                                        onChecked: function() {
                                            handleSetTag(groupedTag, filteredTagIds.includes(groupedTag.sys.id) ? "remove" : "add");
                                        }
                                    };
                                })
                            }
                        })
                    }, groupName || "Others");
                })
            })
        })
    });
}
function ShopFilterTopBar_ListRoot(param) {
    var list = param.list;
    var menuRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var handleOpen = function() {
        setOpen(true);
    };
    var handleClose = function() {
        setOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemSub, {
                open: open,
                item: list,
                ref: menuRef,
                onMouseEnter: handleOpen,
                onMouseLeave: handleClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(horizontal_style/* PaperStyle */.Q, {
                open: open,
                anchorEl: menuRef.current,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "left"
                },
                PaperProps: {
                    onMouseEnter: handleOpen,
                    onMouseLeave: handleClose,
                    sx: {
                        mt: 1.5,
                        maxHeight: 500,
                        minWidth: 200,
                        overflowY: "auto"
                    }
                },
                children: (list.children || []).map(function(item) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                        sx: {
                            display: "block",
                            ml: 0.5
                        },
                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            size: "small",
                            checked: item.checked,
                            onChange: function() {
                                var ref;
                                return (ref = item.onChecked) === null || ref === void 0 ? void 0 : ref.call(item);
                            }
                        }),
                        label: item.title
                    }, item.id);
                })
            })
        ]
    });
}
var NavItemSub = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var item = param.item, active = param.active, open = param.open, onMouseEnter = param.onMouseEnter, onMouseLeave = param.onMouseLeave;
    var title = item.title, children = item.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(horizontal_style/* ListItemStyle */.q, {
        ref: ref,
        subItem: true,
        disableRipple: true,
        open: open,
        activeSub: active,
        onClick: function() {
            !open && (onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter());
        },
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        children: [
            title,
            " ( ",
            children.length,
            " )",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopFilterTopBar_ArrowIcon, {
                open: open
            })
        ]
    });
});
function ShopFilterTopBar_ArrowIcon(param) {
    var open = param.open;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
        icon: open ? "eva:arrow-ios-downward-fill" : "eva:arrow-ios-forward-fill",
        sx: {
            width: 16,
            height: 16,
            ml: 1
        }
    });
}

;// CONCATENATED MODULE: ./src/sections/e-commerce/shop/index.ts








/***/ })

}]);